import { createRoot } from 'react-dom/client'
import App from './App.tsx'
// Self-hosted so the POS keeps its typeface offline and inside Electron/Capacitor.
// Must be imported here rather than from index.css so Vite emits the .woff2 files.
import '@fontsource-variable/inter'
import './index.css'
import { initSentry } from '@/sentry'
import { initCapacitorUpdater } from '@/utils/capacitorUpdater'
import { setupStaleChunkReload } from '@/utils/staleChunkReload'

initSentry()
initCapacitorUpdater()
setupStaleChunkReload()

createRoot(document.getElementById("root")!).render(<App />);
